import { X } from 'lucide-react';
import { Panel } from '@/design-system';
import type { StrategicNote } from '@/domain/presentation/contracts';

export interface StrategicNotesPanelProps {
  notes: readonly StrategicNote[];
  open: boolean;
  onClose: () => void;
}

/**
 * SPEC-011 §38-43/plan §21 — presenter-only side drawer. Body is rendered
 * as plain text (`whitespace-pre-wrap`), never `dangerouslySetInnerHTML`
 * (§43/AC-040: no arbitrary HTML).
 */
export function StrategicNotesPanel({ notes, open, onClose }: StrategicNotesPanelProps) {
  if (!open) return null;
  const visible = notes.filter((note) => note.visible);
  return (
    <aside
      aria-label="Observações estratégicas"
      className="flex w-72 shrink-0 flex-col gap-3 overflow-y-auto border-l border-border-subtle bg-surface p-4"
    >
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-text-primary">Observações estratégicas</h2>
        <button
          type="button"
          aria-label="Fechar observações"
          onClick={onClose}
          className="text-text-muted hover:text-text-primary"
        >
          <X size={16} />
        </button>
      </div>
      {visible.length === 0 ? (
        <p className="text-xs text-text-muted">Não há observações estratégicas para esta apresentação.</p>
      ) : (
        visible.map((note) => (
          <Panel key={note.id}>
            <h3 className="text-sm font-medium text-text-primary">{note.title}</h3>
            <p className="mt-1 whitespace-pre-wrap text-xs text-text-secondary">{note.body}</p>
          </Panel>
        ))
      )}
    </aside>
  );
}
